module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201112_283.de1e75de.jpg";